import { HttpErrorResponse } from '@angular/common/http';
import { Provider } from './../../../models/provider';
import { ProvidersService } from './../../../services/providers.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-providers-home',
  templateUrl: './providers-home.component.html',
  styleUrls: ['./providers-home.component.scss']
})
export class ProvidersHomeComponent implements OnInit {

  public Providers: Provider[];

  constructor(private providerService: ProvidersService, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      const { id } = params;
      this.getProviders(id ? id : null);
    })
  }

  private getProviders(id: string | null) {
    this.providerService.getProviders(id).subscribe(response => {
      if (response instanceof HttpErrorResponse) {
        this.router.navigate(['notfound']);
      } else if (!response) {
        this.router.navigate(['providers']);
      } else {
        this.Providers = response;
      }
    });
  }

}
